import * as React from "react";
import {Component, ReactNode} from "react";
import FormRenderer, {IFormRendererProps} from "./FormRenderer";
import {InputProps} from "reactstrap/lib/Input";
import "./DateRenderer.css";
import {Field, Validator} from 'redux-form';
import InputRenderer from "./InputRenderer";
import Required from "../validations/Required";
import {FormattedMessage} from 'react-intl';

export type IDateRendererProps = IFormRendererProps & InputProps & {
    isRequired?: boolean
}

export default class DateRenderer extends Component<IDateRendererProps> {

    private static YearValidator = (value: string): any => {
        if(!value) {
            return;
        }

        const valueInt = parseInt(value, 10);
        if(valueInt < 1900 || valueInt > new Date().getFullYear()) {
            return <FormattedMessage id="form.validations.date.year.invalid" />;
        }
    };

    private static MonthValidator = (value: string): any => {
        if(!value) {
            return;
        }

        const valueInt = parseInt(value, 10);
        if(valueInt <= 0 || valueInt > 12) {
            return <FormattedMessage id="form.validations.date.month.invalid" />;
        }
    };

    private static DayValidator = (value: string, formData: any): any => {
        if(!value) {
            return;
        }

        const valueInt = parseInt(value, 10);
        if(valueInt <= 0 || valueInt > 31) {
            return <FormattedMessage id="form.validations.date.day.invalid" />;
        }

        // TODO: CHECK DATE
    };

    public render(): ReactNode {

        const {
            input,
            meta,
            label,
            validationDisabled = false,
            isRequired = true,
        } = this.props;
        const { name } = input;

        const validations: Validator[] = (() => {
            const validations: Validator[] = [];

            if(validationDisabled) {
                return validations;
            }

            if(isRequired) {
                validations.push(Required);
            }
            return validations;
        })();

        return (
            <FormRenderer input={input} meta={meta} label={label} className="date-renderer">
                {label}
                <Field name={name + "_year"}
                       label={<FormattedMessage id="field.birthday.year" />}
                       component={DateComponentRenderer}
                       length={4}
                       validate={[...validations, DateRenderer.YearValidator]}
                />
                <Field name={name + "_month"}
                       label={<FormattedMessage id="field.birthday.month" />}
                       component={DateComponentRenderer}
                       length={2}
                       validate={[...validations, DateRenderer.MonthValidator]}
                />
                <Field name={name + "_day"}
                       label={<FormattedMessage id="field.birthday.day" />}
                       component={DateComponentRenderer}
                       length={2}
                       validate={[...validations, DateRenderer.DayValidator]}
                />
            </FormRenderer>
        );
    }
}

export type IDateComponentRendererProps = IFormRendererProps & InputProps & {
    length: number;
}

class DateComponentRenderer extends Component<IDateComponentRendererProps> {

    public onChange = (eventTarget: React.ChangeEvent<HTMLInputElement>) => {
        const value = eventTarget.target.value;
        if(value.length > this.props.length || value.match(/([^0-9]+)/g)) {
            return;
        }

        this.props.input.onChange(value);
    };

    public render(): ReactNode {
        const { arrayIndex, ...rest } = this.props;
        const { input } = this.props;
        const newInput = {
            ...input,
            onChange: this.onChange,
        };
        return (
            <InputRenderer {...rest}
                           input={newInput}
                           hideMessages={true}
            />
        );
    }

}